module.exports = __webpack_public_path__ + "img/stick_patrimoine_patrimoine_religieux.7ae3e3a4.svg";